import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IOneToOneTutorRateVersion,
  IOneToOneTutorRateVersionDeleteVerificationData,
  TOneToOneTutorRateVersionConditionTypes,
  TOneToOneTutorRateVersionStudentAssignedDateConditionTypes,
} from '.';
import {
  AdminApiPaths,
  APIDataProvider,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';

export type TAdminCreateOneToOneTutorRateVersion = {
  name: string;
  hideToUser: boolean;
  conditions?: Array<{
    type: TOneToOneTutorRateVersionConditionTypes;
    logic: TOneToOneTutorRateVersionStudentAssignedDateConditionTypes;
    date: string;
  }>;
};

export type TAdminGetOneToOneTutorRateVersions = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminUpdateOneToOneTutorRateVersion = {
  id: string;
  name: string;
  hideToUser: boolean;
  conditions?: Array<{
    type: TOneToOneTutorRateVersionConditionTypes;
    logic: TOneToOneTutorRateVersionStudentAssignedDateConditionTypes;
    date: string;
  }>;
};

const apiDataProvider = new APIDataProvider();

const adminGetOneToOneTutorRateVersionsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetOneToOneTutorRateVersions) => {
  let path = `${AdminApiPaths.oneToOneTutorRateVersions}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IOneToOneTutorRateVersion>>
  >(path);

  return response.data;
};

export const adminCreateOneToOneTutorRateVersion = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-versions/create',
  async (data: TAdminCreateOneToOneTutorRateVersion) => {
    const path = `${AdminApiPaths.oneToOneTutorRateVersions}`;

    const response = await apiDataProvider.post<
      TApiResponse<IOneToOneTutorRateVersion>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateOneToOneTutorRateVersion = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-versions/update',
  async (data: TAdminUpdateOneToOneTutorRateVersion) => {
    const path = `${AdminApiPaths.oneToOneTutorRateVersions}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<IOneToOneTutorRateVersion>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteOneToOneTutorRateVersion = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-versions/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.oneToOneTutorRateVersions}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IOneToOneTutorRateVersion>
    >(path);

    return response.data;
  }
);

export const adminVerifyOneToOneTutorRateVersionDelete = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-versions/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.oneToOneTutorRateVersions}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<IOneToOneTutorRateVersionDeleteVerificationData>
    >(path);

    return response.data;
  }
);

export const adminGetOneToOneTutorRateVersions = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-versions/list',
  adminGetOneToOneTutorRateVersionsModule
);

export const adminGetOneToOneTutorRateVersionsForDropdown = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-versions/dropdown-list',
  adminGetOneToOneTutorRateVersionsModule
);
